import cloneDeep from 'lodash/cloneDeep'
import { createSelector } from 'reselect'

import { EMPTY_OBJECT } from 'utils/emptyConstants'

import { PARTICIPANTS_ALL_CATEGORY } from 'containers/AwarenessCenter/constants'

// The awarenessCenter slice is injected per-route (store.replaceReducer in
// components/pages/awareness-center/index.js) and dropped again when another
// route injects its own data layer; selectors can still run in that window
// (mounted subscriptions, in-flight epics — e.g. a participants-info request
// still in flight when the user has navigated to /settings/account/general),
// so the slice must be read null-safely (see AwarenessCenter/Campaigns/selectors.js).
const selectAutonomousScheduler = (state) =>
  state.awarenessCenter?.autonomousScheduler ?? EMPTY_OBJECT

const selectError = (state) => selectAutonomousScheduler(state).error
const selectLoader = (state) => selectAutonomousScheduler(state).loader
const selectSubmitLoader = (state) => selectAutonomousScheduler(state).submitLoader
const selectParticipants = (state) => selectAutonomousScheduler(state).participants ?? EMPTY_OBJECT
const selectMonths = (state) => selectAutonomousScheduler(state).months
const selectMembers = (state) => selectAutonomousScheduler(state).members
const selectCandidates = (state) => selectAutonomousScheduler(state).candidates
const selectParticipantsInfoToIncludeMsp = (state) =>
  selectAutonomousScheduler(state).participantsInfoToIncludeMsp
const selectParticipantsInfoToInclude = (state) =>
  selectAutonomousScheduler(state).participantsInfoToInclude ?? EMPTY_OBJECT
const selectParticipantsInfoLoader = (state) =>
  selectAutonomousScheduler(state).participantsInfoLoader
const selectParticipantsNumbers = (state) => selectAutonomousScheduler(state).participantsNumbers
const selectConflictedCompanies = (state) => selectAutonomousScheduler(state).conflictedCompanies

const selectParticipantsInfoToExclude = createSelector(
  selectParticipants,
  selectParticipantsInfoToInclude,
  (participants, participantsInfoToInclude) => {
    const selectedParticipants = participants.included ?? EMPTY_OBJECT
    const participantsToExclude = cloneDeep(participantsInfoToInclude) // deep-clone to not change original
    // options from exclude
    const categoriesToAvoid = [PARTICIPANTS_ALL_CATEGORY]
    categoriesToAvoid.forEach((i) => delete participantsToExclude[i])
    // iterate through included participants
    Object.keys(selectedParticipants)
      .filter((i) => !categoriesToAvoid.includes(i))
      .map((category) => {
        selectedParticipants[category].map((field) => {
          if (Array.isArray(participantsToExclude[category])) {
            // children are in array
            participantsToExclude[category] = participantsToExclude[category].filter(
              (a) => a !== field
            )
          } else if (!Array.isArray(participantsToExclude) && participantsToExclude[category]) {
            delete participantsToExclude[category][field]
          }
        })
      })

    return participantsToExclude
  }
)

export {
  selectError,
  selectLoader,
  selectSubmitLoader,
  selectParticipants,
  selectParticipantsInfoToInclude,
  selectParticipantsInfoToExclude,
  selectMonths,
  selectMembers,
  selectCandidates,
  selectParticipantsNumbers,
  selectParticipantsInfoToIncludeMsp,
  selectConflictedCompanies,
  selectParticipantsInfoLoader,
}
